// additional libs
// import "./utils/lite-youtube-embed";

import "../scss/styles-list.scss";

import { createComponent } from "@bigyouth/base";
import * as features from "./features/exports/list";

Object.values(features).forEach(createComponent); 
